import { baseURL, https } from "../http";
import { showError } from "../utils";

const getPlaidLink = async () => {
  try {
    let response = await https().get(`/plaid/get-session-link`);

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const exchangeToken = async (data) => {
  try {
    let response = await https().post(`/plaid/exchange-public-token`, data);

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const getConnectedAccounts = async () => {
  try {
    let response = await https().get(`/payment/get-connected-accounts`);

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const deleteCustomer = async (id) => {
  try {
    let response = await https().delete(
      `/payment/delete-customer?stripeCustomerId=${id}`
    );

    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const connectCard = async (data, callback) => {
  try {
    let response = await https().post(`/payment/connect-card`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } else callback?.(null, response.data);
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};
const addNewCard = async (data, callback) => {
  try {
    let response = await https().post(`/payment/add-new-card`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } else callback?.(null, response.data);
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};


//  update card if is active is false


const updateCard = async (data, callback) => {
  try {
    let response = await https().post(`/payment/update-card`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } else callback?.(null, response.data);
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};




const addInvoicepayment = async (data, callback) => {
  try {
    let response = await https().post(`/payment/add-invoice-payment`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } 
      
      else callback?.(null, response.data);
 
      
    }
    return response
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};



// ach payment



const addAchpayment = async (data, callback) => {
  try {
    let response = await https().post(`/payment/ach-invoice-payment`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } 
      
      else callback?.(null, response.data);
 
      
    }
    return response
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};

const addInvoicepaymentthroughCashAndCheque = async (data, callback) => {
  try {
    let response = await https().post(`/payment/add-cash-cheque-invoice`, data);

    if (response?.status === 200) {
      return response
    }

  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};
 

const confirmInvoicepayment = async (data, callback) => {
  try {
    let response = await https().post(`/payment/confirm-payment`, data);
    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        callback?.(response?.data?.raw?.message);
      } 
      
    //   else 
    //   {
    //   callback?.(null, response.data);
    // const url = "https://staging.ogiso.io";
    //   window.location.href = url;
    //   // window.open(baseURL, '_blank'); 
    //   }
  
      return response
      
    }

  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    callback(error);
  }
};



const addNewInvoicepayment = async (data) => {
  try {
    console.log('data here',data);
    
    let response = await https().post(`/payment/new-invoice-payment-method`, data);

    if (response?.status === 200) {
      if (response?.data?.type === "StripeCardError") {
        showError(response?.data?.raw?.message, 500);
        // callback?.(response?.data?.raw?.message);
      } 
      
      // else callback?.(null, response.data);
 
      
    }
    return response
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    // callback(error);
  }
};








export {
  getPlaidLink,
  exchangeToken,
  getConnectedAccounts,
  deleteCustomer,
  connectCard,addNewCard,updateCard,
  addInvoicepayment,
  confirmInvoicepayment,
  addInvoicepaymentthroughCashAndCheque,
  addAchpayment,
  addNewInvoicepayment,
};
